import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Printer, ArrowLeft } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { shizaiApi } from './shizaiApi';
import DocumentSheet from './DocumentSheet';

export default function OrderPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    shizaiApi.order(id).then(setOrder).catch(() => setErr(true));
  }, [id]);

  // Safari occasionally silently no-ops `window.print()` if a `position: fixed`
  // overlay is in view or if the call races the first paint. Focus the window
  // first, wait a frame, then print — works on Safari/Chrome/Firefox.
  const doPrint = useCallback(() => {
    try { window.focus(); } catch { /* noop */ }
    requestAnimationFrame(() => {
      try { window.print(); } catch { /* noop */ }
    });
  }, []);

  useEffect(() => {
    if (!order) return;
    const t = setTimeout(doPrint, 700);
    return () => clearTimeout(t);
  }, [order, doPrint]);

  return (
    <div className="min-h-screen bg-zinc-100 py-6 print:py-0 print:bg-white">
      <div className="no-print max-w-[210mm] mx-auto px-4 mb-4 flex items-center justify-between">
        <Button variant="outline" size="sm" onClick={() => navigate(-1)} data-testid="print-back-btn"><ArrowLeft size={15} className="mr-1.5" /> 戻る</Button>
        <Button size="sm" onClick={doPrint} data-testid="print-now-btn" className="bg-teal-700 hover:bg-teal-800"><Printer size={15} className="mr-1.5" /> 印刷</Button>
      </div>
      {err ? <p className="text-center text-sm text-zinc-500 py-20">発注が見つかりません</p> : <DocumentSheet order={order} />}
    </div>
  );
}
